import axios from 'axios'

export default {
    getFolders(){
        return axios.get('/api/folders');
    },

    getFolder(folderId){
        return axios.get('/api/folders/'+folderId);
    }
}
